<template>
    <data-table
        :collection="data.columns"
        :additional-columns="additionalColumns"
        :is-loading="isLoading"
        :row-set="hasDefaultRows ? null : rows"
        with-scroll-sync
    >
        <template #title>
            <div class="flex justify-between items-center">
                <a
                    :href="route('stores.budgets.edit', [data.store.id, data.budgetId])"
                    class="cursor-pointer w-full h-full hover:font-bold"
                    target="_blank"
                >
                    #{{ data.store.number }}
                </a>

                <default-button
                    :color="hasDefaultRows ? 'green' : 'indigo'"
                    :label="$t('storemanager.show-all-rows')"
                    class="ml-2"
                    icon="color-swatch"
                    size="xxs"
                    @click.native="hasDefaultRows = !hasDefaultRows"
                ></default-button>
            </div>
        </template>
    </data-table>
</template>

<script>
import DataTable from '@/Components/Storemanager/DataTable';
import DataColumnCollection from '@/Components/Storemanager/Entities/DataColumnCollection';
import FieldsModel from '@/Models/Contracts/FieldsModel';
import DataColumn from '@/Components/Storemanager/Entities/DataColumn';

export default {
    components: {DataTable},

    props: {
        data: Object,
        date: Date,
        isLoading: Boolean,
        rows: Array,
    },

    data() {
        return {
            hasDefaultRows: false,
            additionalColumns: new DataColumnCollection([], true),
        };
    },

    created() {
        let additionalColumns = [];

        let accumulatedColumn = new DataColumn(
            new FieldsModel(this.data?.results?.accumulated ?? {}, false),
        );

        accumulatedColumn.header = this.$t('general.overall').toString();

        additionalColumns.push(accumulatedColumn);
        this.additionalColumns.columns = additionalColumns;
    },

    computed: {
        currentDate() {
            return moment.utc(this.date);
        },
    },
};
</script>
